module.exports = __webpack_public_path__ + "fonts/Lato-SemiboldItalic.80f6811f.woff2";